import { render, staticRenderFns } from "./approvalExplain.vue?vue&type=template&id=4d63fa9b&scoped=true&"
import script from "./approvalExplain.vue?vue&type=script&lang=js&"
export * from "./approvalExplain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63fa9b",
  null
  
)

export default component.exports